// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"newBlockToolbar__toolbar___3gSJc","button":"newBlockToolbar__button___12XDV"};